import { render } from "./PracticeButton.vue?vue&type=template&id=2fb02760&scoped=true"
import script from "./PracticeButton.vue?vue&type=script&lang=js"
export * from "./PracticeButton.vue?vue&type=script&lang=js"

import "./PracticeButton.vue?vue&type=style&index=0&id=2fb02760&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fb02760"]])

export default __exports__